import React from 'react';
import moment from 'moment';

import SVGIcon from 'src/components/svg';

import { lang, userFullName } from 'src/helpers';

export default class AppointmentItem extends React.PureComponent {
  render() {
    let { item, side, renderOptions } = this.props;
    let { data } = item;
    if (!data) return null;
    let { date } = item;
    let { startDate, disease } = data;
    return (
      <div className={'mc-booked-msg mc-' + side}>
        <div className={'mc-text-msg mc-' + side}>
          {renderOptions}
          <div className={'mc-content'}>
            {lang.t('Your appointment is booked here are the detail.')}
          </div>
          <div className={'mc-flex mc-mt5'} style={{ justifyContent: 'flex-end' }}>
            <div className={'mc-send'}>
              <SVGIcon iconname={'send-status-icon'} />
            </div>
            <div className={'mc-time'}>{date && moment(date).format('hh:mm A')}</div>
          </div>
        </div>
        <div className={'mc-text-msg mc-' + side}>
          <div className={'mc-content'}>
            <div className={'mc-title mc-flex'}>
              <SVGIcon iconname={'calendar-booked-icon'} />
              {lang.t("You're all set!")}
            </div>
            <div className={'mc-title'}>{lang.t('Looking forward to our next check in.')}</div>
            <div className={'mc-flex'}>
              <div className={'mc-flex-col mc-grow'} style={{ minWidth: 0 }}>
                <div className={'mc-label'}>{lang.t('Name')}</div>
                <div className={'mc-value mc-text-truncate'}>{userFullName(data)}</div>
                <div className={'mc-label'}>{lang.t('Date')}</div>
                <div className={'mc-value'}>
                  {startDate && moment(startDate).format('MM/DD/YYYY')}
                </div>
              </div>
              <div className={'mc-flex-col mc-grow'} style={{ minWidth: 0 }}>
                <div className={'mc-label'}>{lang.t('Disease')}</div>
                <div className={'mc-value mc-text-truncate'}>{disease}&nbsp;</div>
                <div className={'mc-label'}>{lang.t('Time')}</div>
                <div className={'mc-value'}>{startDate && moment(startDate).format('hh:mm a')}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
